import { useEpdLcaResultsAdditional } from 'services/api/queries';

import useLcaGridHelper from '../../hooks/useLcaGridHelper';
import { LcaGridNote } from '../GridService';
import {
  LcaResultsAdditionalGridColumns,
  LcaResultsAdditionalGridColumnsPdf,
  createVariationColumnWithDisclaimer,
} from './LcaResultsGridColumns';
import LcaResultsGridExtended from './LcaResultsGridExtended';
import LcaResultsGridExtendedPdf from './LcaResultsGridExtendedPdf';

type TProps = {
  epdVersionId: string;
  isForPdf?: boolean;
  disabled?: boolean;
  preferEnabledAppearanceEvenWhenDisabled?: boolean;
  justificationForInclusion?: string | undefined;
  className?: string;
};

const LcaResultsGridAdditionalVoluntary = ({
  epdVersionId,
  isForPdf,
  disabled,
  preferEnabledAppearanceEvenWhenDisabled,
  justificationForInclusion,
  className,
}: TProps) => {
  const { generalDisclaimerNote, showVariationColumn, createVariationDisclaimerNote } = useLcaGridHelper(epdVersionId);
  const rows = useEpdLcaResultsAdditional(epdVersionId).data;

  const notes: LcaGridNote[] = [];

  if (generalDisclaimerNote) {
    notes.push(generalDisclaimerNote);
  }

  let columns = isForPdf ? LcaResultsAdditionalGridColumnsPdf : LcaResultsAdditionalGridColumns;
  if (showVariationColumn && (!isForPdf || (isForPdf && rows?.some((r) => r.variation)))) {
    const disclaimerNumber = 1;
    columns = [...columns, createVariationColumnWithDisclaimer(disclaimerNumber)];
    notes.push(createVariationDisclaimerNote(disclaimerNumber));
  }

  if (isForPdf) {
    return (
      <LcaResultsGridExtendedPdf
        epdVersionId={epdVersionId}
        rows={rows}
        columns={columns}
        notes={notes}
        justificationForInclusion={justificationForInclusion}
      />
    );
  }

  return (
    <LcaResultsGridExtended
      className={className}
      epdVersionId={epdVersionId}
      rows={rows}
      columns={columns}
      notes={notes}
      disabled={disabled}
      preferEnabledAppearanceEvenWhenDisabled={preferEnabledAppearanceEvenWhenDisabled}
    />
  );
};

export default LcaResultsGridAdditionalVoluntary;
